/**
 * Navigation singleton for use outside React components (thunks, middleware).
 * Set the navigate function from the root router component via setNavigate().
 */
var _navigate = null;
export function setNavigate(navigateFn) {
    _navigate = navigateFn;
}
export function navigate(to) {
    if (_navigate) {
        _navigate(to);
    }
    else {
        console.warn('navigate() called before router was mounted');
    }
}
